export default "__VITE_ASSET__5AxwqjgC__"